import { CommunicationsTabPanel } from "@/pages/communications/components/CommunicationsTabPanel";

export function CommunicationsTab({ id, name }: { id: string; name: string }) {
  return (
    <CommunicationsTabPanel ownerType="spv_pool" ownerId={id} ownerLabel={name} />
  );
}
